import React from "react";
import { IconProps } from "../icon";

export const CloudRaining_02Icon = ({ size = "24px", color = "#000", ...props }: IconProps<string, string>) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M16 12v8m-8-8v8m4-6v8m8-6.758a4.5 4.5 0 00-2.08-8.223 6.002 6.002 0 00-11.84 0A4.5 4.5 0 004 15.242"
    />
  </svg>
);
